import { APIClient } from "./_api"

const endpoint = "/OrderNote"

export function getOrderNote(values) {
  return APIClient.post(`${endpoint}/filter`, values)
}

export function getOrderNoteType() {
  return APIClient.get(`${endpoint}/types`)
}

export function addOrderNote(values) {
  return APIClient.post(`${endpoint}`, values)
}


export function editOrderNote(values, id) {
  return APIClient.put(`${endpoint}/${id}`, values)
}